import { postApi, getApi, putApi, deleteApi } from 'apis';

const createShiftMaster = async (data: any) => {
	return await postApi('/shift-master', data);
};

const getShiftMasters = async (data: any) => {
	return await getApi('/shift-master', data);
};

const updateShiftMaster = async (id: string, data: any) => {
	return await putApi(`/shift-master/${id}`, data);
};

const deleteShiftMaster = async (id: string) => {
	return await deleteApi(`/shift-master/${id}`);
};

export const shiftMasterApi = {
	getShiftMasters,
	createShiftMaster,
	updateShiftMaster,
	deleteShiftMaster,
};
